<template>
  <div>
    <h1 class="text-center mb-5">Strømabonnement</h1>
    <v-flex xs12>
      <v-flex xs12 sm8 offset-sm2 class="mb-5">
        <slick ref="slick" :options="slickOptions" @afterChange="updateCurrentSlide" v-if="slickReady">
          <template v-for="(item, index) in powerSubs">
            <div class="text-center" :key="index+'1'">
              <img :src="item.img" class="mb-3 logo-img" />
              <h4>{{item.title}}</h4>
              <p v-html="item.description"></p>
            </div>
          </template>
        </slick>
        <div v-else>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-flex>
    </v-flex>
    <v-flex xs12 class="mt-4">
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="stepValues.movingDateFormatted"
            label="Dato avlesing strømmåler"
            prepend-icon="mdi-event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          first-day-of-week="1"
          locale="no"
          v-model="stepValues.movingDate"
          @input="menu2 = false"
          @change="formatDate"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 class="mt-4">
      <PersonList
        title="Abonnement bestilles til"
        v-model="this.participants.tenants"
        dialogText="<p>Her angis personene strømabonnementet skal bestilles på</p>"
        @person-added="newPersonAdded"
        @update-list="updateFields"
        @person-removed="personRemoved"
        :max="1"
      ></PersonList>
    </v-flex>
    <v-flex xs12 class="mt-4" v-if="companies">
      <h4 class="mb-3">Eller velg bestilling til bedrift:</h4>
      <v-select
        label="Velg ansvarlig for strømbestillingen"
        v-model="stepValues.selectedTenant"
        :items="companies"
        @change="companyChange"
      >
        <template
          slot="selection"
          slot-scope="data"
        >{{ data.item.companyName }}</template>
        <template
          slot="item"
          slot-scope="data"
        >{{ data.item.companyName }}</template>
      </v-select>
      <v-btn
        color="primary"
        dark
        class="mt-2"
        v-on:click.stop="stepValues.selectedTenant = null"
        v-if="stepValues.selectedTenant"
      >Angre</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-card class="mb-4 mt-4">
        <v-toolbar color="accent" :dark="protocol.dark">
          <v-toolbar-side-icon>
            <v-icon>mdi-home</v-icon>
          </v-toolbar-side-icon>
          <v-toolbar-title>Adresse for strømmåler</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                box
                hide-details
                label="Gatenavn"
                type="text"
                v-model="protocol.saved_values.address.street"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pr-sm-2 mt-4">
              <v-text-field
                box
                hide-details
                label="Postnummer"
                type="number"
                v-model="protocol.saved_values.address.zip"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pl-sm-2 mt-4">
              <v-text-field
                box
                hide-details
                label="Poststed"
                type="text"
                v-model="protocol.saved_values.address.city"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import PersonList from "../../form/PersonList.vue";
import Slick from "vue-slick";
import step from "../../../mixins/step";
export default {
  mixins: [step],
  components: { PersonList, Slick },
  data() {
    return {
      participants: [],
      menu2: false,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        initialSlide: this.stepValues.currentSlide
      },
      powerSubs: null,
      slickReady: false
    };
  },
  beforeMount: function() {
    this.stepValues.selectedTenant = null
    this.participants = this.protocol.saved_values.participants
    if(!this.stepValues.movingDate) {
      this.stepValues.movingDate = new Date().toISOString().substr(0, 10)
      this.formatDate()
    }
    this.axios
    .get(
        process.env.VUE_APP_PROTOCOL_API +
          "power_products/" +
          this.protocol.hash
      )
      .then(response => {
        if (!response.data) {
          this.errored = true;
          this.errorText = "Feil: Kunne ikke hente strømabonnementer";
        } else {
          this.powerSubs = response.data
          this.slickOptions.initialSlide = this.stepValues.currentSlide
          this.slickReady = true
          if (!this.stepValues.powerSub) {
            this.stepValues.powerSub = this.powerSubs[this.stepValues.currentSlide];
          }
        }
      })
      if(this.protocol.saved_values.participants.tenants.length > 0) {
        this.stepValues.selectedTenant = this.protocol.saved_values.participants.tenants[0]
      }
      this.protocol.saved_values.powerOrder = this.stepValues
  },
  methods: {
    next: function() {
      if (this.finished) {
        this.$emit("next-page");
      }
      this.$emit("page-not-finished");
      return false
    },
    updateCurrentSlide() {
      this.stepValues.currentSlide = this.$refs.slick.currentSlide();
      this.stepValues.powerSub = this.powerSubs[this.stepValues.currentSlide];
      this.updateFields()
    },
    formatDate () {
      const [year, month, day] = this.stepValues.movingDate.split('-')
      this.stepValues.movingDateFormatted = `${day}.${month}.${year}`
      this.updateFields()
    },
    newPersonAdded() {
      this.stepValues.selectedTenant = this.protocol.saved_values.participants.tenants[0]
      this.updateFields()
    },
    personRemoved() {
      if(this.protocol.saved_values.participants.tenants.length == 0) {
        this.stepValues.selectedTenant = null
      }
    },
    companyChange(company) {
    }
  },
  computed: {
    finished: function() {
      if (!this.stepValues.selectedTenant) {
        this.$emit(
          "error",
          "Vennligst velg hvem strømbestillingen skal bestilles til"
        );
        return false
      } else {
        if(!this.protocol.saved_values.address.street 
          || !this.protocol.saved_values.address.zip 
          || !this.protocol.saved_values.address.city) {
          this.$emit(
            "error",
            "Vennligst velg adresse for strømbestilling"
          );
          return false
        }
      }
      return true
    },
    companies: function() {
      if (this.protocol.version.protocol_definition.department.company.options.power_order_companies) {
        return this.protocol.version.protocol_definition.department.company.options.power_order_companies
      }
      return null
    }
  }
};
</script>
